const steps = [
  {
    icon: "ri-phone-line",
    title: "Free Consultation",
    desc: "Call us or fill out our form. We'll discuss your energy goals, answer questions, and schedule your free home assessment.",
  },
  {
    icon: "ri-home-smile-line",
    title: "Home Assessment",
    desc: "Our certified technician visits your home to evaluate your roof, attic, HVAC system, and energy usage patterns.",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Custom Proposal",
    desc: "We design a tailored solution with detailed savings projections, financing options, and available rebates.",
  },
  {
    icon: "ri-tools-line",
    title: "Professional Installation",
    desc: "Our licensed, insured crews complete your installation with minimal disruption — most projects finish in 1-2 days.",
  },
  {
    icon: "ri-shield-star-line",
    title: "Ongoing Support",
    desc: "Enjoy your savings with confidence. We provide monitoring, maintenance, and warranty support for years to come.",
  },
];

export default function ProcessTimeline() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Our Simple 5-Step Process
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From your first call to enjoying lower energy bills, we make the entire
            experience seamless and stress‑free.
          </p>
        </div>

        <div className="relative">
          {/* Connection line for large screens */}
          <div className="hidden lg:block absolute top-16 left-[10%] right-[10%] h-0.5 bg-gray-200"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {steps.map((step, i) => (
              <div
                key={step.title}
                className="relative text-center group"
              >
                <div className="relative z-10 w-16 h-16 flex items-center justify-center bg-brand-red rounded-2xl mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-brand-red/20">
                  <i className={`${step.icon} text-white text-2xl`}></i>
                </div>
                <span className="inline-block bg-brand-cream text-brand-navy text-xs font-bold px-3 py-1 rounded-full mb-3">
                  Step {i + 1}
                </span>
                <h4 className="font-bold text-gray-900 mb-2 text-lg">
                  {step.title}
                </h4>
                <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
